import React from 'react';
import { useTheme } from '../context/ThemeContext';
import styles from '../styles/Button.module.css';

const Button = ({
  children,
  onClick,
  variant = 'primary', // primary, secondary, success, error, neutral
  size = 'medium', // small, medium, large
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) => {
  const { isDarkMode } = useTheme();

  const getButtonClasses = () => {
    const classes = [
      styles.button,
      styles[variant],
      styles[size],
      isDarkMode ? styles.dark : '',
      fullWidth ? styles.fullWidth : '',
      className
    ];

    return classes.filter(Boolean).join(' ');
  };

  return (
    <button
      className={getButtonClasses()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;